export default {
  errorDefault: 'Virhe on tapahtunut',
  unknown: 'Tuntematon',
};
